import React, { useEffect, useState } from "react";
import "../../styles/navbar.css";
import Logo from "../../assets/TradeIQLogo3.avif";
import { Link } from "react-router-dom";

const Navbar = ({ profile, onLogout }) => {
  /* ======= TOGGLE MENU ======== */
  const [Toggle, showMenu] = useState(false);

  // Ensure state update is applied
  useEffect(() => {
    console.log('Toggle state updated to:', Toggle);
  }, [Toggle]);

  const handleToggle = () => {
    showMenu(!Toggle);
  };

  return (
    <header className="header">
      <nav className="nav">
        <Link to="/" className="nav__logo">
          <img src={Logo} className="logo__image" alt="Home" />
        </Link>

        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <Link to="/" className="nav__link">
                <i className="uil uil-estate nav__icon"></i>Home
              </Link>
            </li>
            <li className="nav__item">
              <Link to="/onboard" className="nav__link">
                <i className="uil uil-signout nav__icon"></i>Onboard
              </Link>
            </li>
            <li className="nav__item">
              <Link to="/login" className="nav__link">
                <i className="uil uil-signout nav__icon"></i>Sign In
              </Link>
            </li>
          </ul>
          <i
            className="uil uil-times nav__close"
            onClick={handleToggle}
          ></i>
        </div>

        <div className="nav__toggle" onClick={handleToggle}>
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};


export default Navbar;
